// https://gist.github.com/hengkiardo/3760884
export const formatMoney = (money: number | string) => {
    money = money?.toString() || ''
    const numericPart = money.replace(/[^\d.]/g, '')

    const result = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(parseFloat(numericPart))

    return result
}
